import React from "react";
import { MappedFieldRow } from "./MappedFieldRow";

// Right column of "Mapped Fields" — accepts drops from AvailableColumnsRail
// chips and renders one MappedFieldRow per current mapping. Empty-state copy
// per the affiliate-export-mapping-ui spec's "Empty State" requirement.
export function MappedFieldsList({ mappings, errors, onUpdate, onRemove, onDropColumn }) {
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const sourceColumn = e.dataTransfer.getData("text/x-export-column");
    if (sourceColumn) onDropColumn(sourceColumn);
  };

  return (
    <div>
      <div style={{ fontSize: 11, color: "#7b7b7b", textTransform: "uppercase", letterSpacing: 1, marginBottom: 10 }}>
        Mapped Fields
      </div>
      <div
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          minHeight: 120,
          border: mappings.length === 0 ? "1px dashed #E2E2E2" : "none",
          borderRadius: 10,
          padding: mappings.length === 0 ? 20 : 0,
        }}
      >
        {mappings.length === 0 && (
          <div style={{ color: "#7b7b7b", fontSize: 13, textAlign: "center" }}>
            Drag a column here, or click one to add it.
          </div>
        )}
        {mappings.map((m) => (
          <MappedFieldRow key={m.rowId} mapping={m} error={errors[m.rowId]} onUpdate={onUpdate} onRemove={onRemove} />
        ))}
      </div>
    </div>
  );
}
